module.exports = __webpack_public_path__ + "static/media/barcode.256904bc.svg";